import React from "react";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { ContainerBox, Table, ModalFooter } from "components";
import SearchBox from "./SearchBox";
import { TABLE_CODE, LOG_ACTION, ACTION_LOG_API_TOKEN } from "../../core/utils/constants"

import {
  ACCESSOR_LOG,
  DATE_FORMAT,
  EMPTY_FORMAT_CELL,
} from "../../core/utils/constants";
import { observer, inject } from "mobx-react";
import moment from "moment";
import "./style.scss";
import BaseComponent from "../BaseComponent";

@inject('actionLogsStore', 'modalStore')
@observer
class ActionLogs extends BaseComponent {
  constructor(props) {
    super(props);
  }

  // table height
  /**
   * columns
   *
   * @returns column objects for table
   */
  columns = () => {
    const { t } = this.props;
    return [
      {
        Header: t("log.no"),
        disableSortBy: true,
        width: "4%",
        accessor: ACCESSOR_LOG.INDEX,
      },
      {
        Header: t("log.action"),
        accessor: ACCESSOR_LOG.ACTION,
        width: "16%",
        Cell: ({ row }) => {
          let action = EMPTY_FORMAT_CELL;
          switch (row?.original?.action) {
            case LOG_ACTION.RECORD_UPLOAD:
              action = t("log.action_record_upload");
              break;
            case LOG_ACTION.CSV_DOWNLOAD:
              action = t("log.action_csv_download");
              break;
            case LOG_ACTION.FORM_DEFINITION_UPLOAD:
              action = t("log.action_form_definition_upload");
              break;
            case LOG_ACTION.CORRECT_READING_RESULT:
              action = t("log.action_correct_reading_result");
              break;
            case LOG_ACTION.LOGIN:
              action = t("log.action_login");
              break;
            case LOG_ACTION.LOGOUT:
              action = t("log.action_logout");
              break;
            case LOG_ACTION.DELETE_DOCUMENT:
              action = t("log.action_delete_document");
              break;
            case LOG_ACTION.DEBUG_DOWNLOAD:
              action = t("log.action_debug_download");
              break;
            case LOG_ACTION.RECORD_DOWNLOAD:
              action = t("log.action_record_download");
              break;
            case LOG_ACTION.IMPORT_CLAUDE:
              action = t("log.action_import_claude");
              break;
            case LOG_ACTION.EXPORT_CLAUDE:
              action = t("log.action_export_claude");
              break;
            case LOG_ACTION.ADD_CLAUDE:
              action = t("log.action_add_claude");
              break;
            case LOG_ACTION.UPDATE_CLAUDE:
              action = t("log.action_update_claude");
              break;
            case LOG_ACTION.DELETE_CLAUDE:
              action = t("log.action_delete_claude");
              break;
            case LOG_ACTION.FORM_DEFINITION_DELETE:
              action = t("log.action_form_definition_delete");
              break;
          }
          return action;
        },
      },
      {
        Header: t("log.action_detail"),
        accessor: ACCESSOR_LOG.ACTION_DETAIL,
        width: "35%",
        className: "cell-action-detail",
        Cell: ({ row }) =>
          row?.original?.actionDetail
            ? row?.original?.actionDetail
            : EMPTY_FORMAT_CELL,
      },
      {
        Header: t("log.user_id"),
        accessor: ACCESSOR_LOG.USER_ID,
        width: "30%",
        Cell: ({ row }) => {
          let userId = row?.original?.userId;
          if (userId !== undefined && userId !== null && userId.includes(ACTION_LOG_API_TOKEN)) {
            // IPアドレスの抽出
            let matches = userId.match(/\((.*)\)/);
            if (matches !== null && matches.length > 1) {
              let ipAddrs = matches[1].split(',').map(e => e.trim());
              if (ipAddrs.length > 0 && ipAddrs[0]) {
                // クリックすると全IPを表示するように出力
                return <div className="color-theme cursor-p" onClick={() => this.showIpAddrListModal(ipAddrs)}>
                  {userId.replace(new RegExp(`${ACTION_LOG_API_TOKEN} \(.*\)`), `${t("log.user_id.api_token")} (${ipAddrs[0]})`)}
                </div>;
              }
            }
            // IPアドレスが見つからない場合の文言変換
            userId = userId.replace(ACTION_LOG_API_TOKEN, t("log.user_id.api_token"));
          }
          return userId;
        }
      },
      {
        Header: t("log.executed_at"),
        accessor: ACCESSOR_LOG.EXECUTED_AT,
        Cell: ({ row }) =>
          row?.original?.executedAt
            ? moment(row?.original?.executedAt).format(DATE_FORMAT.full_time)
            : EMPTY_FORMAT_CELL,
        width: "15%",
      },
    ];
  };

  /**
   * componentWillMount
   * get list actionLogs from BE
   *
   */
  componentWillMount = () => {
    const { t } = this.props;
    this.props.actionLogsStore.clean();
    this.props.actionLogsStore.getActionLogs(t);
  };

  /**
   * handleDownload
   * handle download actions
   *
   */
  handleDownload = (data) => {
    const { t } = this.props;
    this.props.actionLogsStore.applySearchBoxFiler();
    this.props.actionLogsStore.downloadActionLogs(t);
  };

  /**
   * handleUpdate
   * update screen follow search filter
   *
   */
  handleUpdate = () => {
    const { t } = this.props;
    this.props.actionLogsStore.updatePagingFiler({ page: 1 });
    this.props.actionLogsStore.applySearchBoxFiler();
    this.props.actionLogsStore.getActionLogs(t);
  };

  renderSearchElement = () => {
    const { t } = this.props;

    return (
      <button
        className="download-btn-style btn btn-primary mb-3"
        type="button"
        onClick={this.handleUpdate}
      >
        {t("log.btn_update")}
      </button>
    );
  };

  onFetch = (tableData) => {
    const { t } = this.props;
    this.props.actionLogsStore.updatePagingFiler(tableData);
    this.props.actionLogsStore.getActionLogs(t);
  };

  handleCloseModal() {
    const { modalStore } = this.props;
    modalStore.hideAll();
  }

  // IPアドレスのリストをダイアログに表示
  showIpAddrListModal = (ipAddrList) => {
    const { modalStore, t } = this.props;
    modalStore.show({
      id: "ipaddrlist",
      isOpen: true,
      header: t('log.ip_address_modal.title'),
      onCancel: () => this.handleCloseModal(),
      children: (
        <div className="text-c">
          <div key={"modal-body"} className="modal-body">
            {
              ipAddrList.map((ipAddr, idx) => {
                return <span key={idx}>{ipAddr}</span>
              })
            }
          </div>
          <ModalFooter key={"modal-footer"}
            saveButtonText={t('log.ip_address_modal.close')}
            onConfirm={() => this.handleCloseModal()}
          />
        </div>
      ),
      type: 'small'
    });
  };

  /**
   * render
   * render download main content
   *
   */
  render() {
    const { t } = this.props;
    let customSelectedBox = [10, 50, 100, 500, 1000];
    return (
      <div className="screen-action-log">
        <ContainerBox headerTitle={t("log.title")} className="search-container">
          <div className="box-body box-profile">
            <SearchBox savedData={this.props.location.state?.savedSearchState} />
          </div>
        </ContainerBox>
        <ContainerBox type="basic" className="action-log-container table-container">
          <div className="box-body document-item-info">
            <button
              className="download-btn-style btn btn-primary f-r mb-3 btn-download-action-log"
              type="button"
              onClick={this.handleDownload}
            >
              {t("log.download")}
            </button>
            <Table
              tblCode={TABLE_CODE.LOG}
              columns={this.columns()}
              data={this.props.actionLogsStore?.actionLogs}
              t={t}
              element={this.renderSearchElement()}
              customSelectedBox={customSelectedBox}
              disablePaging={false}
              onFetch={this.onFetch}
              enableServerSidePaging={true}
              initialTableState={this.props.actionLogsStore?.paging}
            />
          </div>
        </ContainerBox>
      </div>
    );
  }
}
export default withRouter(withTranslation()(ActionLogs));
